import { render, staticRenderFns } from "./ImprimBookHome.vue?vue&type=template&id=238ff413&scoped=true&"
import script from "./ImprimBookHome.vue?vue&type=script&lang=js&"
export * from "./ImprimBookHome.vue?vue&type=script&lang=js&"
import style0 from "./ImprimBookHome.vue?vue&type=style&index=0&id=238ff413&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238ff413",
  null
  
)

export default component.exports